import * as React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'

export default function Pincodes(props) {
  const { label, value, onChange } = props
  return (
    <FormControl fullWidth size='small'>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={onChange}
      >
        <MenuItem value={'ALL'}>All Serviceable Pincodes</MenuItem>
        <MenuItem value={'MANUAL'}>Enter Manually for Specific Pincodes</MenuItem>
      </Select>
    </FormControl>
  )
}
